import React, { useState } from 'react'
import { Select, Radio } from 'antd'
import { app } from 'xadmin'
import Uploading from './pages/Uploading'
const Option = Select.Option

const ThemeSelect = (props) => {
  const { input } = props
  const data = app.map('themes')

  const onChange = value => {
    input.onChange(value)
  }

  const value = JSON.stringify(data) == '{}' ? undefined : input.value

  return (
    <Select
      showSearch
      placeholder="请选择主题"
      value={value}
      style={{ minWidth: 150 }}
      onChange={onChange}
      filterOption={(input, option) => (
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )}
    >
      {
        Object.keys(data).length > 0 ?
          Object.keys(data).map(id => <Option value={id}>{data[id].name || id}</Option>)
          : null
      }
    </Select>
  )
}

//管理员向导1
const ResetPwdForm = {
  type: 'object',
  properties: {
    password: {
      title: '管理员密码',
      type: 'string',
      maxLength: 30,
      minLength: 6,
      fieldType: 'password'
    },
    password2: {
      title: '确认密码',
      type: 'string',
      maxLength: 30,
      minLength: 6,
      fieldType: 'password'
    }
  },
  form: [ {
    key: 'password',
    attrs: { type: 'password' },
    validate: value => (/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合')
  }, {
    key: 'password2',
    attrs: { type: 'password' },
    // validate: value => (/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合'),
    validate: (value, { password }) => value == password ? ((/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合')) : '两次输入密码不一致',
  } ]
}
const SceneSelect = (props) => {
  let { input: { onChange, value } } = props
  value = value || 'person'
  React.useEffect(() => { onChange('person') }, [])
  const getSelectVer = e => onChange(e.target.value)
 
  return (
    <div className="loginBox loginScene">
      <p>场景选择</p>
      <div className="version-box">
        <Radio.Group onChange={getSelectVer} value={value}>
          <Radio value={'person'} className={value == 'person' ? 'version-single version-user' : 'version-single version-per'}>
            <img src={require('./images/geren.png')} alt="" />
            <span>个人版</span>
          </Radio>
          <Radio className={value != 'person' ? 'version-single version-user' : 'version-single version-per'} value={'company'}>
            <img src={require('./images/icon.png')} alt="" />
            <span>企业版</span>
          </Radio>
        </Radio.Group>
      </div>
    </div>
     
  )
}
//管理员向导2
const resetSetting = {
  type: 'object',
  properties: {
    scene: {
      type: 'string',
      // title: 'scene'
    },
    // indType: {
    //   type: 'string',
    //   title: '行业选择',
    //   enum: [ '默认', '工业制造', '石油', '石化', '电力', '煤炭', '智慧城市', '渔牧业', '制药', '市政', '农业' ]
    // }
  },
  form: [ { key: 'scene', component: SceneSelect }, //'indType' 
  ]
}
//管理员向导3
const systemSetting = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
      title: '系统名称'
    },
    logo: {
      type: 'string',
      title: '系统logo'
    },
    backgroundImage: {
      type: 'string',
      title: '系统背景'
    }
  },
  form: [ 'name', {
    key: 'logo',
    component: Uploading,
    accept: 'image/*',
    category: 'img'
  },
  {
    key: 'backgroundImage',
    component: Uploading,
    accept: 'image/*',
    category: 'img'
  } ],
  required: [ 'name' ]
}

const front_systemSetting = {
  type: 'object',
  properties: {
    reception_name: {
      title: '系统名称',
      type: 'string'
    },
    copyright: {
      type: 'string',
      title: '系统版权信息'
    },
    reception_logo: {
      title: '系统logo',
      type: 'string',
    },
    backgroundImage: {
      'title': '系统背景',
      'type': 'string'
    },
    layout: {
      'title': '系统布局',
      'type': 'string',
      'enum': [ 'layout1', 'layout2' ],
      'enum_title': [ '左侧菜单', '顶部菜单' ]
    },
    theme: {
      'title': '系统主题',
      'type': 'string'
    }
  },
  form: [ 'reception_name', 'copyright', { key: 'reception_logo', component: Uploading, accept: 'image/*', category: 'img' }, 
    { key: 'backgroundImage', component: Uploading, accept: 'image/*', category: 'img' }, 'layout', 
    { key: 'theme', component: ThemeSelect } ],
  required: [ 'reception_name' ]
}

export { ResetPwdForm, resetSetting, systemSetting, front_systemSetting }
